import { getData, putData } from '../plugins/ApiCalls'

export function fetchCredentials() {
  return getData('credentials')
}

export function bulkUpdateCredentials(data) {
  return putData(`credentials/bulk-update`, data)
}
